if (!customElements.get('product-sticky-cart')) {
  customElements.define(
    'product-sticky-cart',
    class ProductStickyCart extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.stickyButton = this.querySelector('[data-sticky-product-submit]');
        this.stickyLabel = this.querySelector('[data-sticky-product-label]');
        this.stickyPrice = this.querySelector('[data-sticky-product-price]');
        this.mainButton = document.getElementById(`ProductSubmitButton-${this.sectionId}`);

        if (!this.mainButton || !this.stickyButton) return;

        this.stickyButton.addEventListener('click', this.handleClick);
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, this.handleVariantChange);
        this.buttonObserver = new MutationObserver(this.syncFromMainButton);
        this.buttonObserver.observe(this.mainButton, {
          attributes: true,
          childList: true,
          subtree: true,
        });
        this.visibilityObserver = new IntersectionObserver(this.handleVisibility, { threshold: 0 });
        this.visibilityObserver.observe(this.mainButton);

        this.syncFromMainButton();
        this.hidden = false;
      }

      disconnectedCallback() {
        this.stickyButton?.removeEventListener('click', this.handleClick);
        this.variantChangeUnsubscriber?.();
        this.buttonObserver?.disconnect();
        this.visibilityObserver?.disconnect();
      }

      handleClick = () => {
        if (this.mainButton?.disabled || this.mainButton?.getAttribute('aria-disabled') === 'true') return;
        this.mainButton.click();
      };

      handleVariantChange = ({ data }) => {
        if (data.sectionId !== this.sectionId) return;

        const skuRow = document.querySelector(`[data-product-tech-sku-row="${this.sectionId}"]`);
        const skuValue = document.querySelector(`[data-product-tech-sku="${this.sectionId}"]`);
        if (skuRow && skuValue) {
          skuValue.textContent = data.variant?.sku || '';
          skuRow.hidden = !data.variant?.sku;
        }

        requestAnimationFrame(this.syncFromMainButton);
      };

      handleVisibility = ([entry]) => {
        const hasPassedMainButton = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
        this.classList.toggle('is-visible', hasPassedMainButton);
        this.setAttribute('aria-hidden', hasPassedMainButton ? 'false' : 'true');
      };

      syncFromMainButton = () => {
        if (!this.mainButton) return;

        const mainLabel = this.mainButton.querySelector('span')?.textContent.trim();
        if (mainLabel) this.stickyLabel.textContent = mainLabel;

        const isDisabled =
          this.mainButton.disabled ||
          this.mainButton.getAttribute('aria-disabled') === 'true' ||
          this.mainButton.classList.contains('loading');
        this.stickyButton.disabled = isDisabled;

        const priceRoot = document.getElementById(`price-${this.sectionId}`);
        const currentPrice =
          priceRoot?.querySelector('.price--on-sale .price-item--sale') ||
          priceRoot?.querySelector('.price__regular .price-item--regular');
        if (currentPrice) this.stickyPrice.innerHTML = currentPrice.innerHTML;
      };
    }
  );
}
